import { StaticLocationParamaters } from 'cg-foundation-theming';
var GalleryPageController = (function () {
    function GalleryPageController($scope, lastViewedService, locationService, searchConfiguration, compareChannel, searchResult) {
        var _this = this;
        this.$scope = $scope;
        this.lastViewedService = lastViewedService;
        this.locationService = locationService;
        this.searchConfiguration = searchConfiguration;
        this.compareChannel = compareChannel;
        this.searchResult = searchResult;
        this.$scope.hideFilters = false;
        this.$scope.searchFilterGroups = [];
        this.$scope.searchSorters = [];
        this.$scope.isListView = localStorage.getItem('is-list-view') === 'true';
        this.$scope.initiallySelectedFilters = this.locationService.get(StaticLocationParamaters.filters, true, ';');
        this.$scope.excludedThirdPartyDevices = this.locationService.get(StaticLocationParamaters.thirdPartyProducts, true);
        this.$scope.thirdPartyDevices = this.searchResult.thirdPartyProducts;
        this.$scope.solutions = this.searchResult.solutions;
        if (!Array.isArray(this.searchResult.matchingGroupIds)) {
            this.searchResult.matchingGroupIds = [];
        }
        this.searchConfiguration.get().then(function (configuration) {
            _this.$scope.searchSorters = configuration.sorters;
            _this.$scope.searchSortersLabel = configuration.sortersLabel;
            _this.handleSorter();
            _this.$scope.searchFilterGroups = configuration.filterGroups;
            _this.$scope.hideFilters = _this.$scope.searchFilterGroups.length === 0;
        });
        this.$scope.onSortChange = function (sorter) {
            _this.locationService.set(StaticLocationParamaters.orderBy, sorter === undefined || !sorter.sortingExpression ? null : "" + sorter.sortingExpression);
        };
        this.$scope.onFilterChange = function (selectedFilters) {
            if (selectedFilters === void 0) { selectedFilters = []; }
            _this.locationService.set(StaticLocationParamaters.filters, selectedFilters.length === 0 ? null : selectedFilters.join(';'));
        };
        this.$scope.onDevicesChange = function (devices) {
            _this.compareChannel.reset();
            _this.lastViewedService.addLastViewed(devices);
            _this.locationService.set(StaticLocationParamaters.thirdPartyProducts, devices.map(function (d) { return d.searchKey; }));
        };
        var $isListViewWatcher = this.$scope.$watch('isListView', function () {
            localStorage.setItem('is-list-view', String(_this.$scope.isListView));
        });
        $scope.$on('$destroy', function () {
            $isListViewWatcher();
        });
    }
    GalleryPageController.prototype.handleSorter = function () {
        var sorterQuery = this.locationService.get(StaticLocationParamaters.orderBy);
        for (var _i = 0, _a = this.$scope.searchSorters; _i < _a.length; _i++) {
            var sorter = _a[_i];
            if (sorter.sortingExpression === sorterQuery) {
                this.$scope.initiallySelectedSorter = sorter;
                break;
            }
        }
    };
    GalleryPageController.$inject = [
        '$scope',
        'lastViewedService',
        'locationService',
        'searchConfiguration',
        'compareChannel',
        'searchResult',
    ];
    return GalleryPageController;
}());
export { GalleryPageController };
